// namespaced
// @see {@link https://vuex.vuejs.org/guide/modules.html#namespacing | vuex}
const namespaced = true;

// initial state
const state = {
  isReversedLayout: false,
};

// getters
const getters = {
  getIsReversedLayout: state => state.isReversedLayout,
};

// actions
const actions = {
  /**
   * [toggleIsReversedLayout description]
   * @param   {[type]}  commit  [commit description]
   */
  toggleIsReversedLayout ({ commit }) {
    commit("TOGGLE_IS_REVERSED_LAYOUT");
  },
};

// mutations
const mutations = {
  /**
   * [TOGGLE_IS_REVERSED_LAYOUT description]
   * @param   {[type]}  state  [state description]
   */
  TOGGLE_IS_REVERSED_LAYOUT (state) {
    state.isReversedLayout = !state.isReversedLayout;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
